module.exports = __webpack_public_path__ + "static/assets/d442a4b396a6d1e41dca3f3b57c0c452.png";